(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name tracking.service:TrackingHelper
     *
     * @description
     *
     */
    angular
        .module('tracking')
        .service('TrackingHelper', TrackingHelper);

    function TrackingHelper($q, rx, RemoteService, TrackingAdaptorFactory, TrackingRequestFactory, CommonMasterData, EventManagerService, MessageService, TrackingModel) {
        var self = this;

        var model = {
            isFilterActive: false,
            aircraftList: [],
            originalTrackingFlights: [],
            trackingFlights: [],
            paringsIDsForSelectedFlight: {},
            paringsForSelectedFlight: {},
            selectedFlight: null,
            selectedPairing: null,
            selectedCrew: null,
            patternGenderRequirments: {},
            flightDiscrepancies: {},
            timeZone: null,
            currentTime: null
        };

        TrackingModel.flightSearchCriteria.subscribe(onFilghtSearchCriteriaChange);

        TrackingModel.flightSearchResult.subscribe(function (flightsResult) {
            model.trackingFlights = flightsResult;
        });

        TrackingModel.regNumberFilterCriteria.subscribe(onFlightRegNoFilterChange);

        TrackingModel.isRegNumberFilterActive.subscribe(function (isActive) {
            model.isFilterActive = isActive;
        });

        self.loadAirports = function () {
            CommonMasterData.getAirportList(
                function (airportList) {
                    TrackingModel.setAirportsList(airportList);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        self.loadAircraftTypes = function () {
            CommonMasterData.getAircraftTypeList(
                function (aircraftTypeList) {
                    TrackingModel.setAircraftTypes(aircraftTypeList);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        self.loadCrewBase = function () {
            CommonMasterData.getCrewBaseList(
                function (baseList) {
                    TrackingModel.setCrewBase(baseList);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        self.getCrewTypes = function () {
            CommonMasterData.getCrewTypeList(
                function (crewTypes) {
                    TrackingModel.setCrewTypes(crewTypes);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        self.updateFlightSearchCriteria = function (param) {
            var request = TrackingRequestFactory.fleetSearchRequest(param);
            TrackingModel.setFlightSearchCriteria(request);
        };

        function onFilghtSearchCriteriaChange(searchCriteria) {
            if (!!searchCriteria) {
                rx.Observable.forkJoin([
                    RemoteService.searchTrackingFlight(searchCriteria),
                    self.LoadAircraftList()
                ]).subscribe(
                    function (response) {
                        var trackingSearchResponse = response[0];
                        var aircraftList = response[1];
                        var adapted = TrackingAdaptorFactory.searchTrackingFlightAdaptor(trackingSearchResponse, aircraftList)

                        self.setTrackingFlights(adapted, true)
                        TrackingModel.setAircraftList(aircraftList);
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
            }
        }

        function onFlightRegNoFilterChange(filterCriteria) {
            if (filterCriteria && filterCriteria.length > 0) {
                self.applyFlightRegNoFilter(filterCriteria);
            } else {
                self.cancelFlightRegFilter();
            }
        }

        /**
         * Tracking Flight Search Api Helper
         * @param params
         * @param successFn
         * @param errorFn
         */
        self.searchTrackingFlight = function (params, successFn, errorFn) {
            RemoteService.searchTrackingFlight(params).then(
                function (trackingSearchResponse) {
                    if (model.aircraftList.length > 0) {
                        successFn(TrackingAdaptorFactory.searchTrackingFlightAdaptor(trackingSearchResponse, model.aircraftList));
                    } else {
                        self.getAircraftList(function (aircraftList) {
                            successFn(TrackingAdaptorFactory.searchTrackingFlightAdaptor(trackingSearchResponse, aircraftList));
                        });
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        }

        /**
         * Get Aircraft list Helper
         * @param successFn
         * @param errorFn
         */
        self.LoadAircraftList = function () {
            var deferred = $q.defer();
            var req = TrackingRequestFactory.aircraftListRequest();
            CommonMasterData.getAircraftList(req,
                function (aircraftList) {
            		aircraftList = filterACList(aircraftList,'ACT');
            	 	deferred.resolve(aircraftList);

                    //TrackingModel.setAircraftList(aircraftList);
                },
                function (error) {
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }

        function filterACList(aircraftList,status){
        	var acList = [];
    	 	if(!!aircraftList){
    	 		for(var i=0;i<aircraftList.length;i++){
    	 			if(status == null){
    	 				acList.push(aircraftList[i]);
    	 			}else if(aircraftList[i].status === status){
    	 				acList.push(aircraftList[i]);
    	 			}
    	 		}
    	 	}
    	 	return acList;
        }

        /**
         * Tracking Fligst Setter
         * @param trackingFligts
         * @param isReset
         */
        self.setTrackingFlights = function (trackingFligts, isReset) {
            TrackingModel.setFlightSearchResult(trackingFligts);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRACKING.TRACKING_FLIGTS_UPDATED, trackingFligts.length);
        }

        /**
         * Filter by Filght Registration numbers
         * @param filter - Array of flight registration numbers
         */
        self.applyFlightRegNoFilter = function (filter) {
            var flightSource;
            if (model.isFilterActive) {
                flightSource = model.originalTrackingFlights;
            } else {
                flightSource = model.trackingFlights;
                model.originalTrackingFlights = angular.copy(model.trackingFlights);
            }

            var selectedRegNumbers = _.pluck(filter, 'registrationName') || [];

            var filtered = _.filter(model.originalTrackingFlights, function (flight) {
                return selectedRegNumbers.indexOf(flight.registrationName) >= 0;
            })
            self.setTrackingFlights(filtered, true);

            TrackingModel.setRegNumberFilterActiveFlag(true);

        };

        /**
         * Cancel Flight registration number filter
         */
        self.cancelFlightRegFilter = function () {
            if (model.isFilterActive) {
                var tmp = angular.copy(model.originalTrackingFlights);
                model.originalTrackingFlights = null;
                self.setTrackingFlights(tmp, true);

                TrackingModel.setRegNumberFilterActiveFlag(false);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCROLL_TO_TOP, 'trackingGrid');
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SCROLL_TO_LEFT, 'trackingGrid');
            }
        };

        /**
         * Reset Pairings for Selected Flight
         * @param flightLegId
         */
        self.resetPairingsForSelectedFilght = function (flightLegId) {
            model.paringsForSelectedFlight[flightLegId] = undefined;
        };

        /**
         * Update flight warnings in Search Result Flight
         * @param flightLegId
         */
        self.updateFlightInResultPanel = function (flightLegId) {
            var decrepancies = model.flightDiscrepancies[flightLegId];
            var selectedFlight = model.selectedFlight;
            if(!!decrepancies && !!selectedFlight){
                selectedFlight.pairingsOpen = decrepancies.pairingsOpen;
                selectedFlight.nextDutyIllegal = decrepancies.nextDutyIllegal;
                selectedFlight.languageWarningExsist = decrepancies.languageWarningExsist;
                selectedFlight.illegLCrewExsist = decrepancies.illegLCrewExsist;
                selectedFlight.genderWarningExsist = decrepancies.genderWarningExsist;
                selectedFlight.expiredCrewExists = decrepancies.expiredCrewExists;
            }
        };

        /**
         * Get Pairings for Flight
         * @param flightLegId
         */
        self.getPairingsByFlightLegId = function (flight) {
            model.selectedFlight = flight;

            var getPairings = function (promisCol, creIdsForPairing) {
                $q.all(promisCol).then(
                    function (patternsResponse) {
                        if (!!patternsResponse) {
                            var adapted;
                            model.paringsForSelectedFlight[model.selectedFlight.flightLegId].length = 0;
                            angular.forEach(patternsResponse, function (response, key) {
                                if (response && response.pattern) {
                                    adapted = TrackingAdaptorFactory.patterByIdAdaptor(
                                        response,
                                        model.flightDiscrepancies[model.selectedFlight.flightLegId],
                                        creIdsForPairing[response.pattern.patternId],
                                        model.patternGenderRequirments);
                                    if (adapted) {
                                        if (!!model.paringsForSelectedFlight[model.selectedFlight.flightLegId]) {
                                            model.paringsForSelectedFlight[model.selectedFlight.flightLegId].push(adapted);
                                        } else {
                                            model.paringsForSelectedFlight[model.selectedFlight.flightLegId] = [adapted];
                                        }
                                    }
                                }
                            });
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )

            };

            var getGenderRequirments = function (patternIdCol) {
                var deferred = $q.defer();
                var promiseCol = [];
                var flightLegId = model.selectedFlight.flightLegId;
                angular.forEach(patternIdCol, function (patterId) {
                    var param = {
                        flightLegId: flightLegId,
                        patternId: patterId
                    };

                    promiseCol.push(RemoteService.getRequiredGenderCountsForPattern(param))
                });
                if (promiseCol.length > 0) {
                    $q.all(promiseCol).then(
                        function (resultCol) {
                            if (resultCol) {
                                angular.forEach(resultCol, function (value, key) {
                                    model.patternGenderRequirments[patternIdCol[key]] = value.assignedGenderDTO || null;
                                });
                            }
                            deferred.resolve();
                        },
                        function (error) {
                            //if error silently ignore gender warnings
                            deferred.resolve();
                        }
                    );
                }
                return deferred.promise;
            };

            var getDiscrepanciesForFlight = function (flightLegId) {
                var deferred = $q.defer();
                var request = TrackingRequestFactory.allDiscrepancyRequest(flightLegId);
                RemoteService.getAllDiscrepanciesByFlightLegId(request).then(
                    function (response) {
                        model.flightDiscrepancies[flightLegId] = response.allDiscrepancyDTO;
                        self.updateFlightInResultPanel(flightLegId);
                        deferred.resolve();
                    },
                    function (error) {
                        deferred.reject(error);
                    }
                )
                return deferred.promise;
            };

            RemoteService.getPairingsByFlightLegId(model.selectedFlight.flightLegId).then(
                function (pairingsResponse) {
                    model.paringsIDsForSelectedFlight = pairingsResponse && pairingsResponse.pairings && pairingsResponse.pairings[model.selectedFlight.flightLegId];
                    var promisCol = [];
                    var creIdsForPairing = {};

                    angular.forEach(model.paringsIDsForSelectedFlight, function (obj) {
                        creIdsForPairing[obj.patternId] = obj.crewIds;
                        promisCol.push(RemoteService.getPatternById(obj.patternId));
                    });

                    //get Required Gender counts for Pattern
                    var patternIdCol = _.pluck(model.paringsIDsForSelectedFlight, 'patternId');
                    promisCol.push(getGenderRequirments(patternIdCol));

                    //get Flight Discrepancies
                    promisCol.push(getDiscrepanciesForFlight(model.selectedFlight.flightLegId));

                    if (promisCol.length > 0) {
                        getPairings(promisCol, creIdsForPairing);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        /**
         * Get Current Time
         * @param successFn
         * @param errorFn
         */
        self.getCuttentTime = function (successFn, errorFn) {

            var getTime = function (timeZone) {
                CommonMasterData.getCurrentTime(timeZone,
                    function (response) {
                        var param = {
                            dateStr: response.localDate,
                            timeStr: response.localTime
                        };
                        model.currentTime = param;
                        successFn(model.currentTime);
                    },
                    function (error) {
                        errorFn(error);
                    }
                )
            };

            if (!!model.timeZone) {
                getTime(model.timeZone);
            } else {
                CommonMasterData.getTrackingTimeZone(
                    function (appParamValueDTO) {
                        if (!!appParamValueDTO) {
                            model.timeZone = appParamValueDTO.paramValue;
                            getTime(model.timeZone);
                        }
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            }
        };


        /**
         * Get Pairing by Pairing Id
         * @param patternId
         * @param flightLegId
         */
        self.getPairingById = function (patternId, flightLegId, crewIdsForPairing) {
            if (!!model.paringsForSelectedFlight[flightLegId] && !!_.find(model.paringsForSelectedFlight[flightLegId], {patternId: patternId})) {
                return;
            }

            RemoteService.getPatternById(patternId).then(
                function (response) {
                    var adapted = TrackingAdaptorFactory.patterByIdAdaptor(response, model.selectedFlight, crewIdsForPairing);

                    if (adapted) {
                        if (!!model.paringsForSelectedFlight[flightLegId]) {
                            model.paringsForSelectedFlight[flightLegId].push(adapted);
                        } else {
                            model.paringsForSelectedFlight[flightLegId] = [adapted];
                        }
                    }

                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        /**
         * Assign Crew to Pairing
         * @param crewProfileId
         * @param pattern
         * @param isRequest
         * @param isCallFromDayOff
         * @param isContinueIllegal
         * @param isUserConfirm
         * @param successFn
         * @param errorFn
         */
        self.assignCrewToPairing = function (crewProfileId, patternId, flags, successFn, errorFn) {
            var param = TrackingRequestFactory.assignPatternRequest(crewProfileId, patternId, flags);
            RemoteService.assignPattern(param).then(
                function (response) {
                    successFn(TrackingAdaptorFactory.assignCrewToPairingAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.assignEvent = function (param, successFn, errorFn) {
            RemoteService.assignEvent(param).then(function (response) {
                successFn(response)
            }, function (error) {
                errorFn(error);
            });
        };

        /**
         * Check Wether warnings applicable when assign new crew to pairing
         * @param crewTypeMasterCode
         * @returns {boolean}
         */
        self.isWarningCheckApplicable = function (crewTypeMasterCode) {
            return crewTypeMasterCode == 'CC';
        };

        /**
         * Get Validation Expired Crews for selected Flight
         * @returns {null|*|Array}
         */
        self.getValidationExpiredCrews = function (patternId) {
            if (model.selectedFlight && model.selectedFlight.validationExpiredCrews) {
                return _.where(model.selectedFlight.validationExpiredCrews, {patternId: patternId}) || [];
            } else {
                return [];
            }
        };

        /**
         * Get Current Duty illegal crew list for selected flight
         * @param patternId
         * @returns {Array}
         */
        self.getCurrentIllegalCrews = function (patternId) {
            if (model.selectedFlight && model.selectedFlight.dutyIllegalCrews) {
                return _.where(model.selectedFlight.dutyIllegalCrews, {patternId: patternId}) || [];
            } else {
                return [];
            }
        };

        /**
         * Unassign crew from pairing
         * @param successFn
         * @param errorFn
         */
        self.unAssignCrew = function (params, successFn, errorFn) {
            var request = TrackingRequestFactory.unAssignCrewRequest(params);
            RemoteService.unAssignBlock(request).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get Gender Warnings for Selected Flight
         * @returns {*}
         */
        self.getGenderWarnings = function () {
            if (model.selectedFlight && model.flightDiscrepancies[model.selectedFlight.flightLegId]) {
                var allDiscrepancies = model.flightDiscrepancies[model.selectedFlight.flightLegId];
                return allDiscrepancies.genderDTOs || [];
            } else {
                return [];
            }
        };

        /**
         * Get Language Warnings for Selected Flight
         * @returns {*}
         */
        self.getLanguageWarnings = function () {
            if (model.selectedFlight && model.flightDiscrepancies[model.selectedFlight.flightLegId]) {
                var allDiscrepancies = model.flightDiscrepancies[model.selectedFlight.flightLegId];
                return allDiscrepancies.languageDTOs || [];
            } else {
                return [];
            }
        };

        /**
         * Get Open Pairing Requirment for selected flight
         * @returns {*}
         */
        self.getOpenPairingWarning = function () {
            if (model.selectedFlight && model.flightDiscrepancies[model.selectedFlight.flightLegId]) {
                var allDiscrepancies = model.flightDiscrepancies[model.selectedFlight.flightLegId];
                return allDiscrepancies.openPairingDTOs || [];
            } else {
                return [];
            }
        };

        /**
         * Get All Discrepancies for Flight
         * @param flightLegId
         * @param successFn
         * @param errorFn
         */
        self.getAllDiscrepancies = function (flightLegId, successFn, errorFn) {
            var request = TrackingRequestFactory.allDiscrepancyRequest(flightLegId);
            RemoteService.getAllDiscrepanciesByFlightLegId(request).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get Next Duty Illegal Crew List for Selected Filght
         * @param patternId
         * @returns {Array}
         */
        self.getNextIllegalCrews = function () {
            if (model.selectedFlight && model.selectedFlight.nextDutyIllegalList) {
                return model.selectedFlight.nextDutyIllegalList;
            } else {
                return [];
            }
        };


        /**
         * Get Crew list for pairing
         * @param patternId
         */
        self.getCrewForPairing = function (patternId, successFn, errorFn) {
            RemoteService.loadCrewReqByPattern(patternId).then(
                function (response) {
                    if (response.success) {
                        successFn(TrackingAdaptorFactory.getCrewForPairingAdaptor(response));
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get Sugested Crew List
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.getSugestedCrewList = function (param, successFn, errorFn) {
            var requestParam = TrackingRequestFactory.trackingSuggestionRequest(param);
            RemoteService.getSugestedCrewList(requestParam).then(
                function (response) {
                    successFn(TrackingAdaptorFactory.getSugestedCrewListAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.getSuggestedUnassignedCrewList = function (param, successFn, errorFn) {
            var requestParam = TrackingRequestFactory.getTrackingUnassignedRequest(param);
            RemoteService.getBlankDays(requestParam).then(
                function (response) {
                    successFn(TrackingAdaptorFactory.getUnassignedCrewListAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };


        /**
         * Aircraft list Getter
         * @returns {*|TrackingHelper.aircraftList|Array|string}
         */
        self.aircraftList = function () {
            return model.aircraftList;
        };

        /**
         * Tracking Flights Getter
         * @returns {Array}
         */
        self.trackingFlights = function () {
            return model.trackingFlights;
        };

        /**
         * Get Pairing IDS For Selected Flight Getter
         * @returns {Array}
         */
        self.pairingIdsForSelectedFlight = function () {
            return model.pairingIdsForSelectedFlight;
        };

        self.setSelectedPairing = function (pairing) {
            model.selectedPairing = pairing;
        };

        self.getSelectedPairing = function () {
            return model.selectedPairing;
        };

        self.setSelectedCrew = function (crew) {
            model.selectedCrew = crew;
        };

        self.getSelectedCrew = function (crew) {
            return model.selectedCrew;
        };

        /**
         * Swap Crew for Pairing
         * @param firstCrew
         * @param secondCrew
         * @param flags
         * @param successFn
         * @param errorFn
         */
        self.swapCrewForPairing = function (firstCrew, secondCrew, flags, successFn, errorFn) {
            var request = TrackingRequestFactory.swapRequest(firstCrew, secondCrew, flags);
            RemoteService.swap(request).then(
                function (response) {
                    successFn(TrackingAdaptorFactory.swapResponseAdaptor(response, [firstCrew, secondCrew]));
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        /**
         * Get pairings for Selected Flight
         * @param flightLegId
         * @returns {*|Array}
         */
        self.pairingsForSelectedFlight = function (flightLegId) {
            if (angular.isUndefined(model.paringsForSelectedFlight[flightLegId])) {
                model.paringsForSelectedFlight[flightLegId] = [];
            }
            return model.paringsForSelectedFlight[flightLegId];
        };

        self.trackingOpenFlightPairsAdaptor = function(flightPairs){
          adaptOpenFlights(flightPairs);
          return flightPairs;
        };

        function adaptOpenFlights(flightPairs){
          flightPairs = _.groupBy(flightPairs,'pairStartDate');

          flightPairs = avoidPairsOverlap(flightPairs);
          return flightPairs;
        }

        function avoidPairsOverlap(flightPairs){
          var rowMinMax = [];
          var tmpMomentStart;
          var tmpMomentEnd;

          angular.forEach(Object.keys(flightPairs), function (dateKey) {
            angular.forEach(flightPairs[dateKey], function (pattern) {
              var pairStart = pattern.pairStartDate + " " + pattern.pairStartTime;
              var pairEnd = pattern.pairEndDate + " " + pattern.pairEndTime;
              tmpMomentStart = moment(pairStart, 'DD/MM/YYYY HH:mm');
              tmpMomentEnd = moment(pairEnd, 'DD/MM/YYYY HH:mm');
              pattern.rowIndex = getRowIndex(rowMinMax, tmpMomentStart, tmpMomentEnd);
            });
          });

          return flightPairs;
        }

        function getRowIndex(rowMinMax, start, end) {
          var obj;
          var rowIndex = -1;
          for (var i = 0; i < rowMinMax.length; i++) {
            obj = rowMinMax[i];
            if (
              (end.isSameOrBefore(rowMinMax[i].minDate, 'minute')) || (start.isSameOrAfter(rowMinMax[i].maxDate, 'minute'))
            ) {
              updateMinMax(rowMinMax, i, start, end);
              rowIndex = i;
              break;
            }
          }

          if (rowIndex == -1) {
            rowIndex = rowMinMax.length;
            updateMinMax(rowMinMax, rowIndex, start, end);
          }
          return rowIndex;
        }

        function updateMinMax(yCol, index, start, end) {
          if (angular.isUndefined(yCol[index])) {
            yCol[index] = {};
          }

          if (angular.isUndefined(yCol[index].minDate) || start < yCol[index].minDate) {
            yCol[index].minDate = start;
          }

          if (angular.isUndefined(yCol[index].maxDate) || end > yCol[index].maxDate) {
            yCol[index].maxDate = end;
          }
        }

    }
}());
